import { FeederType } from './feeder.model';
import { ServiceRequestHistoryDataOut } from '../_modules/customers/_models/kyc-account-data';

export class SurveyDetails {
  id: number = 0;
  customerId: number = 0;
  accountNo: string = '';
  accountName: string = '';
  address: string = '';
  currentTariff: string = '';
  region: string = '';
  district: string = '';
  feederName: string = '';
  dtId: number = 0;
  dtName: string = '';
  geographicalRegion: string = '';
  subgeographicalRegion: string = '';
  acLineName: string = '';
  substationId: number = 0;
  substationName: string = '';
  oldMeterNo: string = '';
  assignedDate: string = '';
  submittedDate: string = '';
  approvedDate: string = '';
  rejectedDate: string = '';
  assignedUser: string = '';
  assignedBy: string = '';
  approvedBy: string = '';
  rejectedBy: string = '';
  paymentStatus: string = '';
  currentStatus: string = '';
  organizationId: number = 0;
  projectType: string = '';
  mapId: string = '';
  mapVendorName: string = '';
  dueDate: string = '';
  reopenStatus: string = '';
}

export class SurveyDetailsPage {
  existingCableSize: string = '';
  existingMeterEnclosure: string = '';
  inputCableDistance: string = '';
  installationType: string = '';
  meterLocation: string = '';
  numberOfServiceWires: string = '';
  outputCableDistance: string = '';
  plannedMeterBrandId: number | null = null;
  recommendedCableSize: string = '';
  recommendedMeterType: string = '';
  serviceWireTraceableToMeterPoint: string = '';
  serviceWiresCondition: string = '';
  surveyInstallationStatus: string = '';
  projectType: string = '';
  remarksAndRecommendations: string = '';
  existingMeterInLocation: string = '';
  dt: SurveyDt = new SurveyDt();
  substation: SurveySubstation = new SurveySubstation();
  customer: SurveyCustomer = new SurveyCustomer();
  images: SurveyImage[];
  installationMaterialRequirements: InstallationMaterialRequirements[] = [];
  customerLoadEstimates: CustomerLoadEstimates[] = [];
  isolationPoint: string = '';
  rejectionNote: string = '';
  latitude: number = 0;
  longitude: number = 0;
  surveyHistory: SurveyHistory[] = [];
  serviceRequestHistory: ServiceRequestHistoryDataOut[] = [];
}

export class SurveyDt {
  dtId: string = '';
  dtName: string = '';
  dtNumber: string = '';
  feederId: string = '';
  feederName: string = '';
  feederNumber: string = '';
  injectionSubstation: string = '';
  feederType: FeederType.NOT_SELECTED;
}

export class SurveySubstation {
  id: string = '';
  name: string = '';
  number: string = '';
  acLineId: number | null = null;
  acLineName: string = '';
  acLineNumber: string = '';
}
export class SurveyCustomer {
  accountName: string = '';
  accountNumber: string = '';
  address: string = '';
  physicalAddress: string = '';
  areaName: string = '';
  subgeographicalRegionName: string = '';
  buildingOwner: string = '';
  customerId: 3;
  customerType: string = '';
  email: string = '';
  latitude: number = 0;
  longitude: number = 0;
  meterBrand: string = '';
  meterBrandId: number = 0;
  meterStatus: string = '';
  name: string = '';
  oldMeterNo: string = '';
  phoneNo: string = '';
  regionName: string = '';
  geographicalRegionName: string = '';
  spn: string = '';
  tariffId: number = 0;
  tariffName: string = '';
  tariffRate: string = '';
  typeOfConnection: string = '';
  itinerary: string = '';
  block: string = '';
  geocode: string = '';
  readingOnMeter: string = '';
  ghanaPostCode: string = '';
  activityCode: string = '';
  currentPlotCode: string = '';
  dtId: number = 0;
  areaId: number = 0;
  subgeographicalRegionId: number = 0;
  substationId: number = 0;
  mapId: string = '';
}
export class InstallationMaterialRequirements {
  id: number = 0;
  installationMaterial: string = '';
  materialCategory: string = '';
  quantity: number = 0;
  unitOfMeasurement: string = '';
}

export class CustomerLoadEstimates {
  equipmentType: string = '';
  id: number = 0;
  quantity: number = 0;
  rating: number = 0;
  totalWattage: number = 0;
}
export class SurveyHistory {
  comment: string = '';
  timeStamp: string = '';
  action: string = '';
  user: string = '';
}
export interface SurveyImage {
  url: string;
  imageType: any;
  latitude?: number;
  longitude?: number;
  physicalAddress?: string;
  lastUpdateTime?: string;
}
export class SurveySave {
  id: number = 0;
  assignedUserId: number = 0;
  customers: number[] = [];
}

export enum FilterByOptions {
  ALL = 0,
  WALL = 1,
  POLE = 2,
}

export enum SurveyInstallationStatus {
  Submitted = 1,
  Approved = 2,
  Rejected = 3,
  Assigned = 4,
  Pending = 5,
  Unvalidated = 6,
}

export enum PaymentStatus {
  Success = 1,
  Pending = 2,
  Failed = 3,
  ReadyForPayout = 4,
  Refunded = 5,
  Unknown = 6,
  Cancelled = 7,
  Expired = 8,
  Aborted = 9,
  FreeMetering = 10
}

export enum SurveyInstallationReopenStatus {
  Initial = 1,
  Reopen = 2,
}
